import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import CardBody from './CardBody';
import CardHeader from './CardHeader';

/**
 * @param {object} props
 * @param {boolean} props.isElevated
 * @param {string} props.className
 * @param {React.ReactNode} props.children
 */
export default function Card({
  isElevated = false,
  className = '',
  children = null,
  ...htmlProps
}) {
  return (
    <UiKit.Flex
      direction="column"
      className={cn(styles.card, { [styles.elevated]: isElevated }, className)}
      {...htmlProps}
    >
      {children}
    </UiKit.Flex>
  );
}

Card.Body = CardBody;
Card.Header = CardHeader;
